<template>
    <v-dialog
        persistent
        v-model="model"
        width="400">

        <v-card>

            <v-card-title>Modify Customer Activity</v-card-title>
            <v-card-text>

                <p-date-picker filled v-model="form.due_date" label="Due Date"></p-date-picker>
                <v-textarea
                    label="Comment"
                    filled
                    v-model="form.comment"
                    hide-details>
                </v-textarea>
                
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="submit" :disabled="loading.submit" :loading="loading.submit">Submit</v-btn>
                <v-btn text @click="model = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import { updateCustomerActivity } from '../../services/sales/customerActivity';
import PDatePicker from '../common/PDatePicker';

export default {
    name: "CustomerActivityEditSpecial",
    components: {
        PDatePicker
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        activity: {
            required: true,
            type: Object
        },
        dueDate: String
    },
    data() {
        return {
            form: {
                due_date: null,
                comment: null
            },
            loading: {
                submit: false
            }
        }
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        submit() {
            this.loading.submit = true;
            updateCustomerActivity({id: this.activity.id, form: this.form})
                .then(response => {
                    this.$emit("update", {...response.data});
                    this.model = false;
                })
                .finally(() => this.loading.submit = false)
        }
    },
    created() {

        this.form.due_date = moment(this.dueDate).isValid() ? this.form.due_date = moment(this.dueDate).add(1, "days").format("YYYY-MM-DD"):this.form.due_date =  new moment().format("YYYY-MM-DD");
            
        

    }
}
</script>